<template>
  <a-modal :title="title" :width="modalWidth" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-table size="middle" rowKey="id" :data-source="list" :columns="columns" :loading="dataListLoading"
        :pagination="pagination" @change="pageChange"></a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import pick from 'lodash.pick'
const columns = [
  {
    title: '水表名称',
    dataIndex: 'flowMeterName'
  }, {
    title: '水表编码',
    dataIndex: 'flowMeterNo'
  }, {
    title: '水表厂商',
    dataIndex: 'factory'
  }, {
    title: '安装地址',
    dataIndex: 'address'
  },
  {
    title: '净累积量',
    dataIndex: 'cleanFlow'
  }, {
    title: '经度',
    dataIndex: 'longitude'
  },
  {
    title: '纬度',
    dataIndex: 'latitude'
  },
  {
    title: '水表口径',
    dataIndex: 'diameter'
  },
  {
    title: '水表报警',
    dataIndex: 'flowMeterAlarm'
  }, {
    title: '剩余天数',
    dataIndex: 'flowMeterPower'
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'UserInfo',
  data () {
    return {
      // needPage: false,
      columns,
      queryUrl: 'pipe-network/meter-history/page',
      title: '历史数据',
      modalWidth: 1000,
      visible: false,
      confirmLoading: false,

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      form: this.$form.createForm(this)
    }
  },
  methods: {
    show () {
      this.visible = true
      this.queryList()
    },
    handleCancel () {
      this.close()
    },
    close () {
      this.visible = false
      //   this.disableSubmit = false
      this.selectedRows = []
    },
    handleOk () {
      const that = this
      console.log(that.selectedRows)
      var arr = []
      this.selectedRows.map(item => {
        const obj = this.list.find(items => {
          return items.id == item
        })
        console.log(obj)
        arr.push(obj)
      })
      this.$emit('close', arr)
      this.close()
    }
  }
}
</script>

<style scoped></style>
